module.exports = __webpack_public_path__ + "static/media/book.18662f63.svg";